"use strict";

var _classCallCheck = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var _require = require("../helpers/internal-constants"),
    domSymbolTree = _require.domSymbolTree;

var _require2 = require("../helpers/namespaces"),
    SVG_NS = _require2.SVG_NS;

var _require3 = require("../../utils"),
    mixin = _require3.mixin;

var SVGAnimatedString = require("../generated/SVGAnimatedString");

var ElementImpl = require("./Element-impl").implementation;

var ElementCSSInlineStyleImpl = require("./ElementCSSInlineStyle-impl").implementation;

var GlobalEventHandlersImpl = require("./GlobalEventHandlers-impl").implementation;

var HTMLAndSVGElementSharedImpl = require("./HTMLAndSVGElementShared-impl").implementation;

var SVGElementImpl = /*#__PURE__*/function (_ElementImpl) {
  _inherits(SVGElementImpl, _ElementImpl);

  var _super = _createSuper(SVGElementImpl);

  function SVGElementImpl(args, privateData) {
    var _this;

    _classCallCheck(this, SVGElementImpl);

    _this = _super.call(this, args, privateData);

    _this._initHTMLAndSVGElement();

    _this._initElementCSSInlineStyle();

    _this._initGlobalEvents();

    return _this;
  }

  _createClass(SVGElementImpl, [{
    key: "className",
    get: function get() {
      return SVGAnimatedString.createImpl([], {
        element: this,
        attribute: "class"
      });
    }
  }, {
    key: "ownerSVGElement",
    get: function get() {
      var e = domSymbolTree.parent(this);

      while (e && e.namespaceURI === SVG_NS) {
        if (e.localName === "svg") {
          return e;
        }

        e = domSymbolTree.parent(e);
      }

      return null;
    }
  }, {
    key: "viewportElement",
    get: function get() {
      // TODO: <symbol>/<use> may make this different from ownerSVGElement.
      return this.ownerSVGElement;
    }
  }]);

  return SVGElementImpl;
}(ElementImpl);

SVGElementImpl.attributeRegistry = new Map();
mixin(SVGElementImpl.prototype, ElementCSSInlineStyleImpl.prototype);
mixin(SVGElementImpl.prototype, GlobalEventHandlersImpl.prototype);
mixin(SVGElementImpl.prototype, HTMLAndSVGElementSharedImpl.prototype);
exports.implementation = SVGElementImpl;